export default "__VITE_ASSET__CGFxMGYg__"